export default __webpack_public_path__ + "static/media/pexels-photo.bc9fb6fe.jpeg";